import { useSelector } from 'react-redux';
import fm from 'format-message';
import PropTypes from 'prop-types';
import textStyles from 'config/branding/textStyles';
import { styled, useStyletron } from '@activebrands/core-web/libs/styletron';
import Discount from './Discount';
import VouchersForm from './VouchersForm';

const Wrapper = styled('div', {
    backgroundColor: 'var(--color-bg-checkout-summary-total)',
});

const Text = styled('p', {
    display: 'flex',
    justifyContent: 'space-between',
    ...textStyles['Misc/14_110_-0175'],
});

const Subtotal = styled('div', {
    display: 'flex',
    justifyContent: 'space-between',
    color: 'var(--black)',
    padding: ['16px var(--margin-content)', null, null, null, null, '16px var(--margin-content) 24px'],
    borderTop: '1px solid var(--color-border-checkout-subtle)',
    ...textStyles['Misc/16_100_-02'],
});

const OrderTotal = ({
    $style = {},
    voucherLabel = '',
    voucherCodePlaceholder = '',
    showVouchersForm = true,
    isVouchersAvailable,
}) => {
    const [css] = useStyletron();
    const { totals, totalDiscount } = useSelector(state => state.basket);

    return (
        <Wrapper $style={$style}>
            <div
                className={css({
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                    padding: '16px var(--margin-content)',
                })}
            >
                <Text>
                    <span>{fm('Products')}</span>
                    <span>{totals?.productsSum}</span>
                </Text>
                <Text>
                    <span>{fm('Shipping')}</span>
                    <span>{totals?.shippingPriceAsNumber ? totals?.shippingPrice : fm('Free')}</span>
                </Text>
                <Text>
                    <span>{fm('Taxes')}</span>
                    <span>{totals?.finalTaxSum}</span>
                </Text>
            </div>
            {totals?.totalDiscount &&
                totalDiscount.discounts.map(discount => <Discount discount={discount} key={discount.id} />)}
            {showVouchersForm && (
                <VouchersForm
                    placeholder={voucherCodePlaceholder}
                    voucherLabel={voucherLabel}
                    toggleLabel={fm('Add discount code')}
                    isVouchersAvailable={isVouchersAvailable}
                />
            )}
            <Subtotal>
                <div>
                    <span>{fm('Total')}</span>
                    <span className={css({ marginLeft: '4px' })}>{fm('(incl. tax)')}</span>
                </div>
                <span>{totals?.finalPrice}</span>
            </Subtotal>
        </Wrapper>
    );
};

OrderTotal.propTypes = {
    $style: PropTypes.object,
    isVouchersAvailable: PropTypes.bool,
    showVouchersForm: PropTypes.bool,
    voucherCodePlaceholder: PropTypes.string.isRequired,
    voucherLabel: PropTypes.string,
};

export default OrderTotal;
